module.exports = __webpack_public_path__ + "static/media/member.8b95acbd.png";